<script>
import DatePicker from "vue2-datepicker";
import { required } from "vuelidate/lib/validators";
import { authComputed } from "@/state/helpers";

export default {
  props: {},
  data() {
    return {
      cardForm: {
        mobile_email: "",
        brand: "",
        membership_no: "",
        membership_level: "",
        issue_date: "",
        validity: "",
        notes: "",
      },
      submitted: false,
      isBtnLoading: false,
      addNewCardFormOpen: false,
      viewCardDetails: true,
      isValidEmail: true,
    };
  },
  validations: {
    cardForm: {
      mobile_email: { required },
      brand: { required },
      membership_no: { required },
      membership_level: { required },
      issue_date: { required },
      validity: { required },
    },
  },
  components: {
    DatePicker,
  },
  computed: {
    ...authComputed,
  },
  methods: {
    handleSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.cardForm.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        this.isBtnLoading = false;
        console.log(this.cardForm);
      }
    },
    // Method is used to check input is email or mobile
    checkEmailOrMobile() {
      if (/[a-zA-Z]/g.test(this.cardForm.mobile_email)) {
        this.isValidEmail =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            this.cardForm.mobile_email
          );
      }
    },
  },
};
</script>

<template>
  <div>
    <div class="offcanvas-header py-0">
      <h4 class="offcanvas-title" id="offcanvasExampleLabel">Card Details</h4>
    </div>
    <div class="offcanvas-body">
      <b-card no-body class="shadow-none">
        <b-card-header
          header-tag="header"
          role="tab"
          v-b-toggle.viewCardDetails
        >
          <h6 class="my-1" slot="header">View list of card</h6>
        </b-card-header>
        <b-collapse
          id="viewCardDetails"
          :visible="viewCardDetails"
          accordion="my-accordion"
          role="tabpanel"
        >
          <b-card-body>
            <b-card-text>
              <div class="mb-0">
                <div class="table-responsive mb-0">
                  <table
                    class="table table-hover mb-0"
                    ref="my-table"
                    infinite-scroll-disabled="busy"
                    infinite-scroll-distance="10"
                  >
                    <!-- v-infinite-scroll="getCards" -->

                    <thead class="table-light">
                      <tr>
                        <th>Email/mobile</th>
                        <th>Card</th>
                        <th>Membarship No</th>
                        <th>Membarship Leval</th>
                        <th>Issue Date</th>
                        <th>Validity</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>7284880004</td>
                        <td><i class="fab fa-cc-visa fa-2x"></i></td>
                        <td>295888004645</td>
                        <td>1</td>
                        <td>12/2025</td>
                        <td>12/2035</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="shadow-none">
        <b-card-header
          header-tag="header"
          role="tab"
          v-b-toggle.addNewCardFormOpen
        >
          <h6 class="my-1" slot="header">Add New MemberShip</h6>
        </b-card-header>
        <b-collapse
          id="addNewCardFormOpen"
          :visible="addNewCardFormOpen"
          accordion="my-accordion"
          role="tabpanel"
        >
          <b-card-body>
            <b-card-text>
              <form
                ref="guest-form"
                @submit.stop.prevent="handleSubmit"
                class="tablist"
              >
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group
                      class="mb-4"
                      label="Email/Mobile"
                      label-for="email_mobile"
                    >
                      <b-form-input
                        id="mobile_email"
                        type="text"
                        autocomplete="off"
                        placeholder="Enter Mobile / Email"
                        v-model="cardForm.mobile_email"
                        @input="checkEmailOrMobile"
                        :class="{
                          'is-invalid':
                            (submitted && $v.cardForm.mobile_email.$error) ||
                            (submitted && !isValidEmail),
                        }"
                      ></b-form-input>
                      <div
                        v-if="submitted && $v.cardForm.mobile_email.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.cardForm.mobile_email.required"
                          >Mobile / Email is required.</span
                        >
                      </div>
                      <div v-if="!isValidEmail" class="invalid-feedback">
                        <span>Enter Valid Email.</span>
                      </div>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group class="mb-4" label="Brand" label-for="brand">
                      <b-form-select
                        class="form-select"
                        id="brand_type"
                        type="text"
                        autocomplete="off"
                        v-model="cardForm.brand"
                        :class="{
                          'is-invalid': submitted && $v.cardForm.brand.$error,
                        }"
                      >
                        <option value="bw">BW</option>
                        <option value="hyatt">Hyatt</option>
                        <option value="choice">Choice</option>
                      </b-form-select>
                      <div
                        v-if="submitted && $v.cardForm.brand.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.cardForm.brand.required"
                          >Brand is required.</span
                        >
                      </div>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group
                      class="mb-4"
                      label="Membership No"
                      label-for="mm_no"
                    >
                      <b-form-input
                        id="mm_no"
                        type="text"
                        placeholder="Enter Membership No"
                        v-model="cardForm.membership_no"
                        autocomplete="off"
                        :class="{
                          'is-invalid':
                            submitted && $v.cardForm.membership_no.$error,
                        }"
                      ></b-form-input>
                      <div
                        v-if="submitted && $v.cardForm.membership_no.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.cardForm.membership_no.required"
                          >Membership No is required.</span
                        >
                      </div>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group
                      class="mb-4"
                      label="Membership Level"
                      label-for="mm_level"
                    >
                      <b-form-input
                        id="mm_level"
                        type="number"
                        placeholder="Enter Membership level"
                        v-model="cardForm.membership_level"
                        autocomplete="off"
                        :class="{
                          'is-invalid':
                            submitted && $v.cardForm.membership_level.$error,
                        }"
                      ></b-form-input>
                      <div
                        v-if="submitted && $v.cardForm.membership_level.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.cardForm.membership_level.required"
                          >Membership Level is required.</span
                        >
                      </div>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group
                      class="mb-4"
                      label="Issue Date"
                      label-for="issue_date"
                    >
                      <date-picker
                        class="w-100 question-date"
                        v-model="cardForm.issue_date"
                        value-type="YYYY-MM-DD"
                        autocomplete="off"
                        :class="{
                          'is-invalid':
                            submitted && $v.cardForm.issue_date.$error,
                        }"
                      ></date-picker>
                      <div
                        v-if="submitted && $v.cardForm.issue_date.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.cardForm.issue_date.required"
                          >Issue Date is required.</span
                        >
                      </div>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group
                      class="mb-4"
                      label="Issue Date"
                      label-for="validity"
                    >
                      <date-picker
                        class="w-100 question-date"
                        v-model="cardForm.validity"
                        value-type="YYYY-MM-DD"
                        autocomplete="off"
                        :class="{
                          'is-invalid':
                            submitted && $v.cardForm.validity.$error,
                        }"
                      ></date-picker>
                      <div
                        v-if="submitted && $v.cardForm.validity.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.cardForm.validity.required"
                          >Validity is required.</span
                        >
                      </div>
                    </b-form-group>
                  </div>
                  <div class="col-md-12">
                    <b-form-group class="mb-2" label="Notes" label-for="notes">
                      <b-form-textarea
                        name="notes"
                        id="notes"
                        placeholder="Type Here Your Notes..."
                        v-model="cardForm.notes"
                        rows="3"
                        autocomplete="off"
                      ></b-form-textarea>
                    </b-form-group>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <button
                      class="btn btn-primary float-end"
                      type="button"
                      @click="handleSubmit"
                      :class="{ disabled: isBtnLoading }"
                    >
                      <i
                        class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                        v-if="isBtnLoading"
                      ></i>
                      Add New Card
                    </button>
                  </div>
                </div>
              </form>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>
